export const digitsOnly = (s: string) => s.replace(/\D/g, "")

export const zipMask = (s: string) => {
  const digits = digitsOnly(s);
  const startDigits = digits.slice(0, 5);
  const endDigits = digits.slice(5, 9);
  return endDigits ? `${startDigits}-${endDigits}` : startDigits;
};